module.exports = __webpack_public_path__ + "img/seven1Orange.a82e6910.jpg";